<template>
  <div>
    <TopBar title="Détails" :cart="false"/>
    <div class="page-content">
      <div class="container bg-white">
        <div v-if="loading" class="dz-spinner color-spinner">
          <div class="spinner-border spinner-sm me-2 mb-2 text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="">
          <div class="order-status-">
            <h5 class="title mb-2 text-start">COM ID #LU-X</h5>
          </div>
          <div class="item-list style-2 recent-jobs-list">
            <ul>
              <OrderRow v-for="(order,index) in order?.meal_sale_elements"
                        :key="index"
                        :index="index"
                        :item="order"
                        :total="order?.order?.length"
              />
            </ul>
          </div>
        </div>
      </div>
      <br> <br> <br> <br>
    </div>
  </div>
</template>

<script setup>

import {useStore} from "vuex";
import { onMounted, ref} from "vue";
import TopBar from "@/views/master/layouts/partials/TopBar";
import {useRoute} from "vue-router";
import OrderRow from "@/components/orderRow";


const store = useStore()
const route = useRoute()

const loading = ref(false)
const order = ref({})

onMounted(() => {
  getOrder()
})


function getOrder(){
  loading.value = true
  store.dispatch('order/loadOrder', route.params.id).then(response => {
    order.value = response.data?.data
  }).finally(() => {
    loading.value = false
  })
}

</script>